export default "<img src=\"{{ image }}\" alt=\"\" *ngFor=\"let image of images\" class=\"visually-hidden\">\n";